import { useState } from "react";
import { getTotalLength } from "@/utils/helper.util";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { SearchFilterItem } from "@/types/SearchFilterItem.type";
import { useIndustryAutocomplete } from "@/hooks/api/search/useIndustryAutocomplete";
import useDebounceQuery from "@/hooks/useDebounceQuery";
import FilterSectionItem from "@/components/molecules/filter/FilterSectionItem";
import FormComboBox from "@/components/molecules/form/FormComboBox";
import IndustryAllHandler from "@/components/organisms/filter/industry/IndustryAllHandler";

const IndustryFilter = ({ name }: SearchFilterItem) => {
  const { t } = useTranslation();
  const { watch } = useFormContext();

  const [industryIncludeQuery, setIndustryIncludeQuery] = useState("");
  const [industryExcludeQuery, setIndustryExcludeQuery] = useState("");

  const {
    query: industryInclude,
    setDebounceQuery: setIndustryInclude,
    isTyping: industryIncludeTyping,
  } = useDebounceQuery();

  const {
    query: industryExclude,
    setDebounceQuery: setIndustryExclude,
    isTyping: industryExcludeTyping,
  } = useDebounceQuery();

  const { data: includedIndustryData, isLoading: isLoadingIndustryInclude } = useIndustryAutocomplete(industryInclude);
  const { data: excludedIndustryData, isLoading: isLoadingIndustryExclude } = useIndustryAutocomplete(industryExclude);

  const industryFilters = watch([
    "industryInclude",
    "industryExclude",
    "advancedIndustryInclude",
    "advancedIndustryExclude",
  ]);

  return (
    <FilterSectionItem
      id={name}
      title={t("search.filter.industry.title")}
      filterCount={getTotalLength(industryFilters)}
      tooltip={t("search.filter.industry.tooltip")}
    >
      <div>
        <FormComboBox
          query={industryIncludeQuery}
          setQuery={(query) => {
            setIndustryIncludeQuery(query);
            setIndustryInclude(query);
          }}
          multiple
          name="industryInclude"
          placeholder={t("search.filter.industry.placeholder")}
          options={includedIndustryData || []}
          allowFreeText={false}
          showOptionsOnFocus
          isLoading={isLoadingIndustryInclude || industryIncludeTyping}
          renderBetween={<IndustryAllHandler formName="advancedIndustryInclude" />}
        />
      </div>

      <div>
        <FormComboBox
          query={industryExcludeQuery}
          setQuery={(query) => {
            setIndustryExcludeQuery(query);
            setIndustryExclude(query);
          }}
          multiple
          name="industryExclude"
          label={t("search.filter.industry.exclude")}
          placeholder={t("search.filter.industry.excludePlaceholder")}
          options={excludedIndustryData || []}
          allowFreeText={false}
          showOptionsOnFocus
          isLoading={isLoadingIndustryExclude || industryExcludeTyping}
          renderBetween={<IndustryAllHandler formName="advancedIndustryExclude" />}
        />
      </div>
    </FilterSectionItem>
  );
};

export default IndustryFilter;
